import React, { useContext, useState } from 'react';
import appContext from '../AppContext';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { sendEmail } from '../services/EmailService';

const EmailModal = ({show, setShow}) => {
    const {locale, schools, gradeFilters, offeringSorts, inBoundaryFilter, searchedPlace} = useContext(appContext);
    const [emailValue, setEmailValue] = useState("");
    const [emailValid, setEmailValid ] = useState(false);
    const [emailSent, setEmailSent] = useState("");
    const [sending, setSending] = useState(false);

    const isEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

    const onChangeEmail = (event) => {
        let emailAddress = event.target.value;
        setEmailValid(isEmail(emailAddress))
        setEmailValue(emailAddress);
    }
 
    const emailResults = () => {
        let inBoundaryString = "Display In-Boundary Schools Only";
        let programfield = "label";
        let schoolIDs = schools.map(school => {
            return school.properties.id;
        });
        let emailData = {
            "Email": emailValue,
            "Schools": schoolIDs.slice(0,52),
            "Link": window.location.href
        };
        if (locale === "es") {
            emailData["Lang"] = "es";
            inBoundaryString = "Muestre las escuelas de la zona escolar, únicamente.";
            programfield = "es";
        }
        if (gradeFilters.length > 0) {
            emailData["Grades"] = gradeFilters;
        }

        if (offeringSorts.length > 0 || inBoundaryFilter) {
            let programs = [];
            if(offeringSorts.length > 0) {
                programs = offeringSorts.map(prog => {
                    return prog[programfield];
                });
            }
            if (inBoundaryFilter) {
                programs.push(inBoundaryString);
            }
            emailData["Programs"] = programs;
        }
        if (searchedPlace !== null) {           
            emailData["Address"] = searchedPlace.properties.FullAddress;
            emailData["LatLong"] = [ searchedPlace.properties.Latitude, searchedPlace.properties.Longitude ];
        }
        try {
            setSending(true);
            sendEmail(emailData).then(response => {
                if (response) {
                    setEmailSent("Email has been sent.");
                } else {
                    setEmailSent("Error sending email. Please contact administrator!");
                }
            }, error => {
                setEmailSent("Error sending email. Please contact administrator!");
            });
        } catch {
            setEmailSent("Error sending email. Please contact administrator!");
        } finally {
            setSending(false);
        }

    }

    const closeModal = () => {
        setShow(false);
        setEmailSent("");
        setEmailValue("");
    }

    return (
        <Dialog open={show}>
            {
                emailSent !== "" ? 
                    <>
                        <DialogTitle>Email Your Results</DialogTitle>
                        <DialogContent>
                            <DialogContentText>{ emailSent }</DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => closeModal()}>Ok</Button>
                        </DialogActions>
                    </>
                :
                <>
                    <DialogTitle>Email Your Results</DialogTitle>
                    <DialogContent>
                        <DialogContentText>Email address to send to:</DialogContentText>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Email Address"
                            type="email"
                            fullWidth
                            onChange={ onChangeEmail }
                            value={ emailValue }
                            variant="standard"
                            />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => closeModal()}>Cancel</Button>
                        <Button disabled={ !emailValid || sending } onClick={() => emailResults()}>Email</Button>
                    </DialogActions>
                </>
            }

        </Dialog>
    );
}
export default EmailModal